export default __webpack_public_path__ + "static/media/problema-09.25bb0320.webp";